import React from "react";
import {CustomPopper} from "~/components/customPopper/CustomPopper.tsx";
import type {Rival} from "../contractExplorerTypes.ts";
import {ConfidenceBadge} from "./ConfidenceBadge.tsx";

const STATUS_NOTE = {
    linked: 'Holds the transaction',
    competing: 'Qualified, but another bundle holds it',
    candidate: 'Below the threshold',
} as const;

type Props = {rivals: Rival[]; onOpen: (contractId: number) => void};

/** The other bundles whose links compete for one transaction, ranked as linkage ranked them. */
export const CompetingBundles: React.FC<Props> = ({rivals, onOpen}) => {
    const [anchor, setAnchor] = React.useState<HTMLElement | null>(null);
    if (!rivals.length) return <span className="ci-dash">—</span>;
    return <>
        <button type="button" className="ci-link"
                onClick={event => {
                    event.stopPropagation();
                    setAnchor(anchor ? null : event.currentTarget);
                }}>
            {rivals.length} {rivals.length === 1 ? 'bundle' : 'bundles'}
        </button>
        <CustomPopper open={anchor !== null} anchorEl={anchor} placement="bottom-end" disablePortal={false}
                      onClose={() => setAnchor(null)} paperSx={{p: 1.5, maxWidth: 380}}>
            <div className="ci-rivals">
                <span className="ci-kv-l">Also linked by</span>
                {rivals.map(rival => (
                    <div key={rival.contract_id} className="ci-rival">
                        <button type="button" className="ci-link ci-rival-t" onClick={() => onOpen(rival.contract_id)}>
                            {rival.title || `Bundle #${rival.contract_id}`}
                        </button>
                        <ConfidenceBadge value={rival.confidence}/>
                        <span className="ci-csub">{STATUS_NOTE[rival.status]}</span>
                    </div>
                ))}
            </div>
        </CustomPopper>
    </>;
};
